import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import StatusBadge from "@/components/StatusBadge";
import MyClientDetailSheet from "@/components/sheets/MyClientDetailSheet";
import api from "@/lib/api";

export default function MyClients() {
  const [clients, setClients] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/clients/my-assigned").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  return (
    <DashboardLayout title="My Clients">
      <p className="text-sm text-[#4B5563] mb-5">Clients you're assigned to as part of the engagement team. Click a row to view tasks, invoices, checklists, and message the client.</p>

      <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden" data-testid="my-clients-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-[#4B5563] border-b border-[#E2E8F0] bg-[#F8F9FA]">
              <th className="px-5 py-3 font-medium">Company</th>
              <th className="px-5 py-3 font-medium">Your Role</th>
              <th className="px-5 py-3 font-medium">Engagement Scope</th>
              <th className="px-5 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 && (
              <tr><td colSpan={4} className="px-5 py-8 text-center text-[#4B5563]">You haven't been assigned to any clients yet.</td></tr>
            )}
            {clients.map((c) => (
              <tr
                key={c.id}
                data-testid={`my-client-row-${c.id}`}
                onClick={() => setSelected(c)}
                className="border-b border-[#E2E8F0] last:border-b-0 hover:bg-[#F8F9FA] cursor-pointer transition-colors duration-200"
              >
                <td className="px-5 py-3 font-medium text-[#1C1C1E]">{c.company_name}</td>
                <td className="px-5 py-3 text-[#00823B] font-medium">{c.my_role}</td>
                <td className="px-5 py-3 text-[#4B5563] max-w-[300px] truncate">{c.engagement_scope}</td>
                <td className="px-5 py-3"><StatusBadge value={c.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <MyClientDetailSheet clientId={selected?.id} myRole={selected?.my_role} open={!!selected} onOpenChange={(v) => !v && setSelected(null)} />
    </DashboardLayout>
  );
}
